import { ROUTES as e } from "./routes.mjs";
import t from "react";
import { Redirect as n, Route as r } from "react-router-dom";
import { useAuth as i } from "@maat/store-auth";
import { Fragment as a, jsx as o } from "react/jsx-runtime";
//#region src/HostRoute.tsx
var s = ({ permission: s, children: c, fallback: l, ...u }) => {
	let { activeProfile: d, permissions: f } = i();
	return /* @__PURE__ */ o(r, {
		...u,
		render: ({ location: r }) => {
			if (d !== "host" || s && !(f.includes("*") || f.includes(s))) return /* @__PURE__ */ o(n, { to: {
				pathname: e.HOME,
				state: { from: r }
			} });
			let i = /* @__PURE__ */ o(a, { children: c });
			return l === void 0 ? i : /* @__PURE__ */ o(t.Suspense, {
				fallback: l,
				children: i
			});
		}
	});
};
//#endregion
export { s as HostRoute };
